import { jsx as _jsx } from "react/jsx-runtime";
import { shallowEqual, useSelector } from 'react-redux';
import { QuestionnaireFlow } from '../../../../redux/questionnaire/typings';
import TransactionDescriptionBanner from '../../../../ui/molecules/TransactionDescriptionBanner';
var shouldShowTransactionBanner = [
    QuestionnaireFlow.Start,
    QuestionnaireFlow.InProgress,
    QuestionnaireFlow.ContactFraud,
    QuestionnaireFlow.CantIdentifyDup,
    QuestionnaireFlow.End,
    QuestionnaireFlow.Exit,
    QuestionnaireFlow.Review,
    QuestionnaireFlow.RedisputeReview
];
var QuestionnaireBanner = function () {
    var _a = useSelector(function (state) { return state; }, shallowEqual), step = _a.questionnaire.step, merchantDesc = _a.transactionData.merchantDesc;
    if (shouldShowTransactionBanner.includes(step)) {
        return _jsx(TransactionDescriptionBanner, { description: merchantDesc });
    }
    return null;
};
export default QuestionnaireBanner;
//# sourceMappingURL=index.js.map